<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label v-if="label">
      <b>{{ label }}</b>
    </v-label>
    <v-text-field
      :value="value"
      @input="onInput"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :outlined="outlined"
      dense
      hide-details="auto"
      append-icon="mdi-magnify"
      @click:append="openModal"
      @keyup.enter="openModal"
      :rules="rules"
      clearable
      @click:clear="onClear"
    ></v-text-field>

    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Buscar: {{ label }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar en la lista..."
            single-line
            hide-details
            outlined
            dense
            clearable
            class="mb-4"
          ></v-text-field>

          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            loading-text="Cargando datos..."
            no-data-text="No hay datos disponibles"
            no-results-text="No hay resultados que coincidan"
            dense
            class="elevation-1"
            @dblclick:row="onRowDblClick"
          >
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeModal">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SaleOrderService from "@/services/ExternalTrade/SaleOrderService.js";

export default {
  name: "SSearchModal",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Buscar..."
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    listCode: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    extraParam: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      search: "",
      loading: false,
      items: []
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onClear() {
      this.$emit("input", null);
      this.$emit("change", null);
    },
    async openModal() {
      if (this.disabled || this.readonly) return;
      this.dialog = true;
      this.search = "";
      if (this.items.length === 0) {
        await this.fetchData();
      }
    },
    closeModal() {
      this.dialog = false;
    },
    async fetchData() {
      this.loading = true;
      try {
        const payload = {
            selected: this.listCode,
            extraParam: this.extraParam ? String(this.extraParam) : null
        };
        const requestID = this.$fun.getUserID();
        const response = await SaleOrderService.list_modal_search(payload, requestID);
        if (response.status === 200 && response.data) {
           this.items = response.data;
        }
      } catch (error) {
        console.error("Error cargando lista modal:", error);
        let msg = typeof error === 'string' ? error : (error.response?.data || error.message);
        this.$fun.alert("Error al cargar la lista: " + msg, "error");
      } finally {
        this.loading = false;
      }
    },
    onRowDblClick(event, { item }) {
      this.$emit("input", item.value);
      this.$emit("change", item);
      this.closeModal();
    }
  }
};
</script>

<style scoped>
::v-deep .v-data-table tbody tr {
    cursor: pointer;
}
::v-deep .v-data-table tbody tr:hover {
    background-color: #f5f5f5 !important;
}
</style>
